import { render, staticRenderFns } from "./CbsInlineAttribute.vue?vue&type=template&id=0e9d73a2&scoped=true"
import script from "./CbsInlineAttribute.vue?vue&type=script&lang=js"
export * from "./CbsInlineAttribute.vue?vue&type=script&lang=js"
import style0 from "./CbsInlineAttribute.vue?vue&type=style&index=0&id=0e9d73a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9d73a2",
  null
  
)

export default component.exports